import { type FC } from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text
} from '@cencosud-cencommerce/paris-uikit';

import type { SendGtmEvent } from '@/modules/shared/utils/gtmEvents/buyNowTypes';
import { BuyNowEventInteractiveTags } from '@/modules/shared/utils/gtmEvents/buyNowTypes';
import { sendEvent } from '@/modules/shared/utils/gtmEvents/sendEvents/sendBuyNowEvents';
import { useMergeFastCheckoutCart } from '@/Pages/BuyNowPage/hooks/useMergeFastCheckoutCart';

interface AddressModalProps {
  isOpen: boolean;
  onClose: () => void;
  loading?: boolean;
}

const SAVED_ADDRESS_MESSAGE =
  'Para una compra rápida usaremos tu dirección guardada. Si quieres elegir otra dirección, ';
const GO_TO_CART_MESSAGE = 'puedes hacerlo desde el carro.';
const BACK_BUTTON_LABEL = 'Volver';
const GO_TO_CART_BUTTON_LABEL = 'Ir al carro';

const GO_TO_CART_EVENT: SendGtmEvent = {
  event: 'baseEvent',
  extraFields: {
    'event-interactive-tag': BuyNowEventInteractiveTags.DireccionesIrAlCarro,
    'event-interactive-accion': 'click'
  }
};

const AddressModal: FC<AddressModalProps> = ({ isOpen, onClose, loading }) => {
  const { mergeAndRedirectToCart } = useMergeFastCheckoutCart();

  if (!isOpen) return null;

  return (
    <Modal size="sm" isOpen={isOpen} onClose={onClose}>
      <ModalHeader
        icon={{
          name: 'il-paris-home'
        }}
        className="[&_h3]:co-text-[0.875rem] tablet:[&_h3]:co-text-[1.25rem]"
        onClose={onClose}
        title="Direcciones"
      />
      <ModalBody className="co-flex co-flex-col co-gap-4 tablet:co-min-h-[244px]">
        <div className="co-flex co-flex-col co-h-500px">
          <div className="co-pt-[8px] co-h-500px">
            <Text variant="body2" weight={400} className="co-h-500px">
              {SAVED_ADDRESS_MESSAGE}
            </Text>
            <Text variant="body2" weight={600}>
              {GO_TO_CART_MESSAGE}
            </Text>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="co-flex co-flex-col-reverse tablet:co-flex-row co-justify-end co-gap-2 [&>*]:co-w-full tablet:[&>*]:co-w-fit">
        <Button block size="xl" variant="secondary" onClick={onClose}>
          {BACK_BUTTON_LABEL}
        </Button>
        <Button
          size="xl"
          variant="primary"
          loading={loading}
          iconLeft="shopping-cart"
          onClick={() => {
            sendEvent(GO_TO_CART_EVENT);
            mergeAndRedirectToCart();
          }}
        >
          {GO_TO_CART_BUTTON_LABEL}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddressModal;
